import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledButton } from "@insite/mobius/Clickable";
import { Link } from "@insite/mobius/index";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PrinterIcon from "@tsesco/Icons/PrinterIcon";
import PrinterIconNew from "@tsesco/Icons/PrinterIconNew";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    printWrapper = "printWrapper",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.printWrapper]: string;
    };
}

export interface PrintStyles {
    titleWrapper?: InjectableCss;
    printWrapper?: InjectableCss;
}

export const printStyle: PrintStyles = {
    printWrapper: {
        css: css`
            margin-top: 3px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            svg {
                color: ${getColor("text.accent")};
                &:hover {
                    color:${getColor("text.accent")};
                    cursor: pointer;
                }
            }
            &:hover {
                color: #6d6e71;
            }
            ${StyledButton} {
                ${TypographyStyle} {
                    text-decoration: underline;
                    color: ${getColor("primary")};
                    font-size: 16px;
                    margin-left: 9px;
                    text-underline-offset: 2px;
                    font-family: roboto-medium;
                    display: flex;
                    align-items: center;
                    &:hover {
                        color: ${getColor("primary")};
                    }
                }
            }
        `,
    },
};

const styles = printStyle;

const printFile = () => {
    window.print();
};

export const SEPrinterWidget: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.printWrapper} data-test-selector="productPrintLink">
            <Link onClick={printFile}>
                <PrinterIconNew />
            </Link>
            <Link onClick={printFile}> {translate("Print")}</Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SEPrinterWidget,
    definition: {
        group: "Basic",
        displayName: "SE Print",
    },
};

export default widgetModule;
